"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Introduction = exports.Title = exports.Form = exports.Error = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var Error = styled_components_1["default"].p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: red;\n  text-align: center;\n"], ["\n  color: red;\n  text-align: center;\n"])));
exports.Error = Error;
var Form = styled_components_1["default"].form(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: white;\n  border-radius: 7px;\n  padding: 30px;\n  min-width: 350px;\n"], ["\n  background-color: white;\n  border-radius: 7px;\n  padding: 30px;\n  min-width: 350px;\n"])));
exports.Form = Form;
var Title = styled_components_1["default"].h2(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
exports.Title = Title;
var Introduction = styled_components_1["default"].p(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
exports.Introduction = Introduction;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
